<template>
  <div v-loading="loading" class="drawer" style="height: calc(100vh - 60px);">
    <div v-show="isHistoryShow" class="drawer-meng" @click="isHistoryShow = false"></div>
    <CommonSearch
      ref="CommonSearch"
      style="border-bottom:none"
      :search-label="searchLabel"
      :show-history-dialog="isHistoryShow"
      @showHistory="isHistoryShow = true"
      @doSearch="defaultSearch"
      @goBack="goBack"
      @changeSearchType="changeSearchType"
    ></CommonSearch>
    <div>
      <el-checkbox v-model="searchFormer" class="searchFormer-checkbox"
        >搜索曾任职公司
        <el-tooltip
          class="item"
          effect="dark"
          content="勾选后通过姓名+公司可以搜索出曾经任职过该公司的人选"
          placement="top"
        >
          <i class="el-icon-warning-outline" style="display: inline;"></i> </el-tooltip
      ></el-checkbox>
    </div>
    <div v-show="result.length > 0" class="drawer-result drawer-result-raidsh">
      <div class="drawer-result-actions">
        <el-button type="text" size="mini" @click="isBatch = !isBatch">
          {{ isBatch ? '进入单个操作' : '进入批量操作' }}
        </el-button>
        <template v-if="isBatch">
          <el-button type="text" size="mini" @click="showIntoProject(null)">加入项目</el-button>
          <el-button type="text" size="mini" @click="showRecommend(null)">推荐</el-button>
          <el-button type="text" size="mini" @click="showIntoFav(null)">加入收藏</el-button>
          <el-button type="text" size="mini" @click="showMerge">合并</el-button>
        </template>
      </div>
      <div class="drawer-box">
        <el-table
          ref="multipleTable"
          :data="result"
          size="mini"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column v-if="isBatch" type="selection" width="35"></el-table-column>
          <el-table-column label="#" :resizable="false" width="40">
            <template slot-scope="scope">
              <el-popover placement="left" trigger="click">
                <div><el-button type="text" size="mini" @click="showIntoProject(scope.row)">加入项目</el-button></div>
                <div><el-button type="text" size="mini" @click="showRecommend(scope.row)">推荐</el-button></div>
                <div><el-button type="text" size="mini" @click="uploadCv(scope.row)">上传简历</el-button></div>
                <div><el-button type="text" size="mini" @click="uploadReport(scope.row)">上传推荐报告</el-button></div>
                <div><el-button type="text" size="mini" @click="genRepo(scope.row)">生成推荐报告</el-button></div>
                <div><el-button type="text" size="mini" @click="showIntoFav(scope.row)">加入收藏</el-button></div>
                <el-button slot="reference" type="text"> <i class="el-icon-setting"></i> </el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="姓名" label="姓名">
            <template slot-scope="scope">
              <div>
                <span
                  class="drawer-link"
                  @click="showRadish({ id: scope.row._id, title: scope.row['姓名'] })"
                  v-html="
                    scope.row.highlights && scope.row.highlights['姓名']
                      ? scope.row.highlights['姓名'][0]
                      : scope.row['姓名']
                  "
                >
                </span>
              </div>
              <div
                style="color:#aaa"
                v-html="
                  scope.row.highlights && scope.row.highlights['手机']
                    ? scope.row.highlights['手机'][0]
                    : scope.row['手机']
                "
              >
                {{ scope.row['手机'] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="公司" label="公司">
            <template slot-scope="scope">
              <span
                v-html="
                  scope.row.highlights && scope.row.highlights['公司']
                    ? scope.row.highlights['公司'][0]
                    : scope.row['公司']
                "
              >
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="职能模块" label="职能模块">
            <template slot-scope="scope">
              <span
                v-html="
                  scope.row.highlights && scope.row.highlights['职能模块']
                    ? scope.row.highlights['职能模块'][0]
                    : scope.row['职能模块']
                    ? scope.row['职能模块'].join('')
                    : ''
                "
              >
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="部门" label="部门">
            <template slot-scope="scope">
              <span
                v-html="
                  scope.row.highlights && scope.row.highlights['部门']
                    ? scope.row.highlights['部门'][0]
                    : scope.row['部门']
                "
              >
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="目前职位" label="目前职位">
            <template slot-scope="scope">
              <span
                v-html="
                  scope.row.highlights && scope.row.highlights['目前职位']
                    ? scope.row.highlights['目前职位'][0]
                    : scope.row['目前职位']
                "
              >
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <UploadDialog ref="UploadDialog" :type="uploadType" :label="attachType" :on-success="uploadSuccess"></UploadDialog>
    <!-- 选择合并时的主数据 -->
    <el-dialog
      title="选择主要数据"
      :visible.sync="isMergeShow"
      :close-on-click-modal="false"
      :modal="false"
      width="500px"
    >
      <el-radio-group v-model="mainRadish">
        <el-radio v-for="item in selectedRadishes" :key="item._id" style="margin-left:0;" :label="item._id">
          <span class="dialog-span drawer-link" @click="showRadish(item)">{{ item.姓名 }}</span>
          <span class="dialog-span" style="color:#aaa">{{ item.手机 }}</span>
          <span class="dialog-span">{{ item.公司 }}</span> <span class="dialog-span">{{ item.部门 }}</span>
          <span class="dialog-span">{{ item.目前职位 }}</span>
          <span class="dialog-span">
            <el-tag v-for="tag in item.职能模块" :key="tag" size="mini">{{ tag }}</el-tag>
          </span>
        </el-radio>
        <br />
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isMergeShow = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmMerge">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { download } from '../../../../project/src/constant/utils'
import { searchLabel2Value, searchPlaceHolder } from '../constant/utils'
import CommonSearch from '../searchBar/CommonSearch'

const searchLabel = '人选'
export default {
  components: { CommonSearch },
  data: function() {
    return {
      searchLabel: searchLabel,
      searchType: searchLabel2Value[searchLabel],
      placeHolder: searchPlaceHolder[searchLabel],
      keywords: '',
      result: [],
      uploadType: '',
      attachType: '',
      currentRow: {},
      isBatch: false,
      selectedRadishes: [],
      isHistoryShow: false,
      isMergeShow: false,
      mainRadish: '',
      loading: false,
      searchFormer: false,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.keywords = ''
      this.result = []
      this.loading = false
    },
    goBack() {
      this.$emit('goBack')
    },
    changeSearchType(type) {
      this.$emit('searchTypeChange', type)
    },
    setSearchHistory() {
      this.searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : {}
      if (!this.searchHistory[this.searchType]) this.searchHistory[this.searchType] = []
      if (!this.searchHistory[this.searchType].includes(this.keywords)) {
        this.searchHistory[this.searchType].unshift(this.keywords)
        localStorage.searchHistory = JSON.stringify(this.searchHistory)
      }
    },
    async doSearch() {
      if (!this.keywords) return this.$message.info('请输入搜索内容')
      this.setSearchHistory()
      this.isHistoryShow = false
      this.loading = true
      const fields = ['姓名^5', '拼音', '公司^5', '职能模块', '手机']
      if (this.searchFormer) {
        fields.push('曾任职公司')
      }
      try {
        await app.service('misc').insertSearchHistory({ type: searchLabel, keywords: this.keywords })
      } catch (e) {}
      const res = await app.service('misc').searchEs({
        type: this.searchType,
        keywords: this.keywords,
        fields,
        and: true,
      })
      if (res.status === 'success') {
        if (res.data.length === 0) this.$message.info('没有符合条件的结果')
        else this.result = res.data
      } else this.$message.error(res.msg)
      this.loading = false
    },
    async showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    defaultSearch({ type, keywords, result, searchFormer }) {
      this.searchType = type
      this.keywords = keywords
      if (searchFormer) {
        this.searchFormer = searchFormer
      }
      this.$refs.CommonSearch.keywords = keywords
      if (result) {
        this.result = result
      } else {
        this.$nextTick(() => {
          this.doSearch()
        })
      }
    },
    handleSelectionChange(val) {
      this.selectedRadishes = val
    },
    showIntoProject(row) {
      const rows = row ? [row] : JSON.parse(JSON.stringify(this.selectedRadishes))
      if (rows.length === 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        app.root.$refs.radishProDialog.show(rows, 'intoProject')
        this.$refs.multipleTable.clearSelection()
      }
    },
    showRecommend(row) {
      const rows = row ? [row] : JSON.parse(JSON.stringify(this.selectedRadishes))
      if (rows.length === 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        for (const r of rows) {
          if (!r['手机']) {
            return this.$alert('cc候选人不能推荐', { showClose: false })
          }
        }
        app.root.$refs.radishProDialog.show(rows, 'recommend')
        this.$refs.multipleTable.clearSelection()
      }
    },
    uploadCv(row) {
      this.currentRow = row
      this.attachType = '原始简历'
      this.uploadType = 'cv'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadReport(row) {
      this.currentRow = row
      this.attachType = '推荐报告'
      this.uploadType = '推荐报告'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      const attach = response.map(res => {
        const extra = { rid: this.currentRow._id, type: this.attachType }
        if (this.attachType === '推荐报告') {
          extra.isFinal = true
        }
        return Object.assign({}, res, extra)
      })
      if (attach.length > 0) {
        const aRes = await app.service('radish').addAttachment(attach)
        if (aRes.status === 'success') {
          this.$message.success({ duration: 500, message: '上传成功' })
        } else {
          this.$message.error(aRes)
        }
      } else {
        this.$message.info('未添加附件')
      }
      this.$refs.UploadDialog.visible()
      this.$refs.UploadDialog.clean()
    },
    async genRepo(row) {
      app.root.$refs.reportMaker.init({ radish: row.rid || row._id })
    },
    showMerge() {
      if (this.selectedRadishes.length < 2) return this.$message('请选择至少勾选2个人选')
      this.mainRadish = ''
      this.isMergeShow = true
    },
    async confirmMerge() {
      if (!this.mainRadish) return this.$message('请选择以哪条数据为主')
      const first = this.mainRadish
      const second = this.selectedRadishes.map(v => v._id).filter(v => v !== first)

      const mergeRes = await app.service('radish').mergeMult({ id: first, first, second })
      if (mergeRes.status === 'success') {
        this.result = this.result.filter(res => !second.includes(res._id))
        this.selectedRadishes = []
        this.isMergeShow = false
        this.$message.success({ duration: 500, message: '合并成功' })
      } else this.$message(mergeRes.msg)
    },
    showIntoFav(row) {
      const rows = row ? [row] : JSON.parse(JSON.stringify(this.selectedRadishes))
      if (rows.length === 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        app.root.$refs.favDialog.show(rows)
        this.$refs.multipleTable.clearSelection()
      }
    },
  },
}
</script>
